/**
 * ハッシュ付きのリンクをスムーススクロールで移動
 * ページ読み込み時にハッシュと同じ id 属性があれば、その要素に移動
 * https://github.com/tsuyoshiwada/sweet-scroll
 */
import SweetScroll from 'sweet-scroll';
const baseNameAttr = 'a[href*="#"]:not([href*="/"]):not([href="#"]):not(#goPageTop)'; // ハッシュ付きリンクをトリガとする

const headerElement = '[data-scroll-header]'; // 固定ヘッダの CSS セレクタ

document.addEventListener('DOMContentLoaded', () => {
  const scroller = new SweetScroll({
    trigger: baseNameAttr,
    // トリガとなる要素を CSS セレクタで指定
    header: headerElement,
    // 固定ヘッダを CSS セレクタで指定
    duration: 700,
    // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint',
    // イージングのタイプ
    offset: 0,
    // スクロール位置のオフセット
    vertical: true,
    // 垂直方向のスクロールの可否
    horizontal: false,
    // 水平方向のスクロールの可否
    cancellable: true,
    // ホイールやタッチイベントによるスクロールの停止可否
    updateURL: true,
    // スクロール完了後に URL を更新する
    preventDefault: true,
    // コンテナ要素のクリックイベント防止
    stopPropagation: true,

    // コンテナ要素のバブリング防止
    // スクロール実行後の処理
    after(offset, $trigger, scrollElement) {
      // スクロール先の要素を id 属性値から取得
      const destination = document.getElementById(scrollElement.ctx.hash.replace('#', '')); // スクロール先にフォーカスを移動

      destination.setAttribute('tabindex', '-1'); // TODO: focus() を有効にするとなぜかスクロール位置がずれてしまう。ヘッダ固定との相性が悪い？
      // destination.focus();
    }

  });
  /**
   * ページ読み込み時に URL のハッシュと同じ id 属性があれば、その要素まで移動する
   */

  const locationHash = window.location.hash;
  const hashExists = locationHash.length >= 1;
  if (!hashExists) return;

  if (hashExists) {
    window.location.hash = '';
  }

  window.addEventListener('load', () => {
    const scrollElement = document.getElementById(locationHash.substr(1));
    const needsInitialScroll = scrollElement !== null;

    if (needsInitialScroll) {
      scroller.to(locationHash, {
        updateURL: 'replace'
      });
    }
  });
});